import type { ReactNode } from "react";
import { openCookieSettings } from "@/lib/cookieConsent";

interface CookieSettingsButtonProps {
  className?: string;
  children?: ReactNode;
}

/** Rouvre le bandeau cookies : le choix se modifie ou se retire aussi simplement qu'il se donne. */
const CookieSettingsButton = ({
  className = "text-primary hover:underline",
  children = "Gérer mes cookies",
}: CookieSettingsButtonProps) => (
  <button type="button" onClick={openCookieSettings} className={className}>
    {children}
  </button>
);

export default CookieSettingsButton;
